export default __webpack_public_path__ + "images/DY.b3294a0.png";